import React from 'react';
import './TrustIndicator.css';

const TrustIndicator = () => {
  return (
    <div className="trust-indicator-container">
      <div className="trust-indicator-content">
        <div className="trust-indicator-text">
          <h3>Evidence-Based Sleep Plans</h3>
          <p>
            Our sleep plans are created using recommendations from Australia's most trusted parenting and child health organizations, 
            enhanced by our curated AI system for personalized guidance.
          </p>
        </div>
        <div className="trust-indicator-organizations">
          <div className="org-item">
            <span className="org-name">Triple P</span>
          </div>
          <div className="org-item">
            <span className="org-name">Red Nose Australia</span>
          </div>
          <div className="org-item">
            <span className="org-name">Raising Children Network</span>
          </div>
          <div className="org-item">
            <span className="org-name">Tresillian</span>
          </div>
        </div>
      </div>
      <div 
        className="trust-indicator-image" 
        style={{ backgroundImage: `url('/images/bastien-jaillot-eJwSOguD1rE-unsplash.jpg')` }}
      ></div>
    </div>
  );
};

export default TrustIndicator;

